import { ReactElement } from 'react';
import styled from 'styled-components';

import FrontImage from '../../assets/images/LandingPage/frontImg.png';
import theme from '../../assets/theme';
import { Button } from '../../components/_atoms/Button';
import QuotesPageContent from '../../components/_organisms/QuotesPageContent';
import { NextPageWithLayout } from '../../components/layouts';
import LandingPageLayout from '../../components/layouts/LandingPageLayout';
import { useMarketingMetrics } from '../../providers/PlausibleAnalyticsProvider';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const PricingPage: NextPageWithLayout = () => {
  return <QuotesPageContent />;
};

const HeaderContainer = styled.div<{ $hideBlobs?: boolean }>`
  position: relative;
  background-color: ${theme.colors.background};
  background-size: cover;
  width: 100%;
  margin: 0px auto;
  color: ${theme.colors.black};
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  justify-content: start;
  align-items: start;
  padding: 50px 30px;

  h1 {
    font-size: 36px;
    margin: 0;
    color: ${theme.colors.black};
  }

  p {
    font-size: 20px;
    font-weight: 600;
    color: ${theme.colors.black};
  }

  ul {
    font-size: 18px;
    margin: 0;
    padding-left: 20px;
  }

  a {
    color: ${theme.colors.blue}; /* Consistent style for <a> */
    text-decoration: none;
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
    height: fit-content;
    padding: 20px 10px;
  }
`;
const CustomHeader = () => {
  const { track } = useMarketingMetrics();

  const formattedEmailBody = `I would like to request a quote please! \n \n My name: \n Email: \n Number of schools I want Curipod for: \n My school's name: \n My district's name: \n Anything else Curipod should know: `;

  return (
    <HeaderContainer>
      <div
        style={{
          display: 'flex',
          gap: 20,
          flexDirection: 'column',
        }}
      >
        <h1>Request a Curipod quote!</h1>
        <p>We are so excited to be partnering with you!</p>
        <p>Please email us at: </p>
        <a
          style={{ color: theme.colors.blue, fontSize: 24, fontWeight: 600 }}
          onClick={e => {
            e.stopPropagation();
            track('QuotesPage.QuotesQuestions.clicked');
          }}
          href={`mailto:quotes@curipod.com?subject=Curipod Quote Request&body=${encodeURIComponent(
            formattedEmailBody,
          )}`}
        >
          quotes@curipod.com
        </a>
      </div>
      <div style={{ display: 'flex', gap: 20, flexDirection: 'column' }}>
        <p>Please include:</p>

        <ul>
          <li>Your name</li>
          <li>Email</li>
          <li>Number of schools you want Curipod for</li>
          <li>Your school&apos;s name</li>
          <li>Your district&apos;s name</li>
          <li>...and anything else we should know.</li>
        </ul>

        <p>
          You will receive formal a quote within 24 hours of your request. Questions or
          concerns? Contact Lexi, Head of US Operations at:{' '}
        </p>
        <p>
          <a
            onClick={e => {
              e.stopPropagation();
              track('QuotesPage.QuotesQuestions.clicked');
            }}
            href="mailto:lexi@curipod.com"
          >
            lexi@curipod.com
          </a>{' '}
          || +47 929 43 686
        </p>
      </div>
    </HeaderContainer>
  );
};

PricingPage.getLayout = function getLayout(page: ReactElement) {
  return (
    <LandingPageLayout
      title="Quotes"
      subTitle="How to get a quote"
      primaryActionText="Sign up - It's free"
      image={FrontImage}
      hideBlobs={true}
      customHeader={<CustomHeader />}
      disableHeadline={true}
    >
      {page}
    </LandingPageLayout>
  );
};

export default PricingPage;
